import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../services/auth.service';
import { FormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';

@Component({
  selector: 'app-signin',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    FormsModule
  ],
  templateUrl: './signin.component.html',
  styleUrl: './signin.component.css'
})
export class SigninComponent {
  email = '';
  password = '';
  error: string | null = null;
  loading = false;

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  signin() {
    this.loading = true;
    this.authService.signin(this.email, this.password)
    .then(() => {
      this.router.navigate(['/dashboard']);
    })
    .catch((error) => {
      this.error = error.message;
    })
    .finally(() => {
      this.loading = false;
    })
  }

  async onForgotPassword(event: Event) {
    event.preventDefault();

    if (!this.email || this.email == '') {
      alert('Please enter your email address first.');
      return;
    }

    try {
      this.loading = true;
      await this.authService.sendPasswordReset(this.email);
      this.loading = false;
      alert('Password reset link sent! Please check your email.');
    } catch (err: any) {
      console.error(err);
      this.loading = false;
      alert('An error occurred: ' + err.message);
    }
  }

}
